import React, { createContext, useState, useContext, useEffect } from "react";
import useFetch from "./functions/useFetch";

// Define user roles using an enum
export enum UserRole {
  USER = 0,
  EDITOR = 1,
  ADMIN = 2,
}

interface UserContextType {
  role: UserRole;
  refreshSession: () => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};

// will log out the user in the frontend, can also be used for a global auto log out from BE
export const HandleFELogout = async () => { 
  const user = useUser();  
  // const { fetchData } = UseFetch();

  if (user.role !== UserRole.USER) {
    user.refreshSession();
    // fetchData("/logout", "POST", {
    //   doOnSuccess: async () => {
    //   },
    //   doOnError: () => {
    //     user.refreshSession(); // on failed log out
    //   },
    // });
  }
};

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [role, setRole] = useState<UserRole>(UserRole.USER);
  const { fetchData } = useFetch<{ auth: number }>();

  // Function to check session status
  const fetchSessionStatus = () => {
    fetchData("/session", "GET", {
      doOnSuccess: (data: { auth: number }) => {
        setRole(data.auth in UserRole ? data.auth : UserRole.USER);
      },
      doOnError: () => {
        setRole(UserRole.USER);
      },
    });
  };

  // Fetch session status on mount
  useEffect(() => {
    fetchSessionStatus();
  }, []);

  return (
    <UserContext.Provider value={{ role, refreshSession: fetchSessionStatus }}>
      {children}
    </UserContext.Provider>
  );
};
